module.exports = __webpack_public_path__ + "h5/img/cs_02.d859cf3a.jpg";